import { FREE_TIER, PRO_TIER, TEAM_TIER } from "./pricing";

export interface PlanConfig {
  name: string;
  price: string;
  maxIncidents: number;
  maxIntegrationsEach: number;
  channels: string[];
  historyDays: number;
  support: string;
  features: string[];
}

export const PLANS = {
  STARTER: {
    name: "Free",
    price: "$0",
    maxIncidents: 5,
    maxIntegrationsEach: FREE_TIER.MAX_INTEGRATIONS_EACH,
    channels: ["slack", "email"],
    historyDays: 7,
    support: "community",
    features: [
      "1 App (Unlimited tools)",
      "5 AI Diagnoses / month",
      "Slack + Email Alerts",
      "ChatGPT & Claude MCP Connect",
      "1 Branded Status Page"
    ]
  } as PlanConfig,
  
  PRO: {
    name: "Pro",
    price: "$49/mo",
    maxIncidents: 50,
    maxIntegrationsEach: PRO_TIER.MAX_INTEGRATIONS_EACH,
    channels: ["slack", "email", "discord", "telegram", "teams"],
    historyDays: 30,
    support: "priority_email_slack",
    features: [
      "5 Apps (Unlimited tools)",
      "75 AI Diagnoses / month",
      "Discord, Telegram & Teams Alerts",
      "Autonomous Self-Healing Webhooks",
      "Advanced Routing (Service → Channel)",
      "25 Custom-Domain Status Pages"
    ]
  } as PlanConfig,

  TEAM: {
    name: "Lifetime Pro",
    price: "$499 one-time",
    maxIncidents: 150,
    maxIntegrationsEach: TEAM_TIER.MAX_INTEGRATIONS_EACH,
    channels: ["slack", "email", "discord", "telegram", "teams", "pagerduty", "jira"],
    historyDays: 90,
    support: "lifetime_priority",
    features: [
      "5 Apps Forever",
      "150 AI Diagnoses / month Forever",
      "Jira Ticketing & PagerDuty Integration",
      "Lifetime Pro Badge (#XXX)",
      "90 Days History Retention"
    ]
  } as PlanConfig
};

export function getPlanConfig(plan: "starter" | "pro" | "team"): PlanConfig {
  if (plan === "pro") return PLANS.PRO;
  if (plan === "team") return PLANS.TEAM;
  return PLANS.STARTER;
}

export function getIncidentLimit(profile: any): number {
  if (profile?.max_incidents_limit !== undefined && profile?.max_incidents_limit !== null) {
    return profile.max_incidents_limit;
  }
  if (profile?.plan === "team") return PLANS.TEAM.maxIncidents;
  if (profile?.plan === "pro" || profile?.is_pro) return PLANS.PRO.maxIncidents;
  return PLANS.STARTER.maxIncidents;
}

export function getMonitorLimit(profile: any): number {
  if (profile?.max_monitors_limit !== undefined && profile?.max_monitors_limit !== null) {
    return profile.max_monitors_limit;
  }
  if (profile?.plan === "team" || profile?.user_mode === "founder") return 5;
  if (profile?.plan === "pro" || profile?.is_pro) return 5;
  return 1; // Free Tier: 1 App
}

export function getStatusPageLimit(profile: any): number {
  if (profile?.max_status_pages_limit !== undefined && profile?.max_status_pages_limit !== null) {
    return profile.max_status_pages_limit;
  }
  if (profile?.plan === "team" || profile?.user_mode === "founder") return 25;
  if (profile?.plan === "pro" || profile?.is_pro) return 25;
  return 1; // Free Tier fallback
}
